import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchTerm: string): any[] {
    if (!items || !searchTerm) {
      return items;
    }

    return items.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
      // Add more conditions if you want to filter based on other properties
    );
  }
}
